export const FORM_FORGOT_PASSSWORD_FILL_EMAIL = 'forgot-password-fill-email';
export const FORM_FORGOT_PASSSWORD_FILL_PASSWORD =
  'forgot-password-fill-password';
export const ACADEMIC_SIGNUP_FORM = 'academic-signup-form';
